/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AgentChartGroupBy extends models.AgentChatAxis {
    getFixupPrototypeFunction() { return AgentChartGroupBy.fixupPrototype; }

    static newInstance(model: Partial<AgentChartGroupBy>): AgentChartGroupBy {
        let obj = Object.assign(new AgentChartGroupBy(), model);
        AgentChartGroupBy.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AgentChartGroupBy>): AgentChartGroupBy {
        if (!model) return null;
        return AgentChartGroupBy.newInstance(<AgentChartGroupBy> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AgentChartGroupBy) {
        if (!obj) return;

        models.AgentChartGroupBy.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AgentChartGroupBy): boolean {
        if (models.AgentChatAxis.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AgentChartGroupBy.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.color) {
            for (let val of this.color) {
                models.KeyValuePair.fixupPrototype(val);
            }
        }
    }

    /**
     * List of tag key/value pairs
     */
    color: Array<models.KeyValuePair>;

}
